import React from "react";
import Carousel from "react-grid-carousel";
import ReviewCard from "./ReviewCard";

const testimonials = [
  {
    name: "Sarah L",
    country: "United States",
    review:
      "Geo VPN is a game-changer! It's fast, easy to use, and I feel so much safer online.",
    image: "https://randomuser.me/api/portraits/women/1.jpg", // Example image URL
  },
  {
    name: "John K",
    country: "United Kingdom",
    review:
      "I've tried several VPNs, but Geo VPN is by far the best. Great speeds and no logs—highly recommend!",
    image: "https://randomuser.me/api/portraits/men/1.jpg",
  },
  {
    name: "Maria Rand",
    country: "Malaysia",
    review:
      "Finally, a VPN that works seamlessly across all my devices. Worth every penny!",
    image: "https://randomuser.me/api/portraits/women/2.jpg",
  },
  {
    name: "Pedro G",
    country: "Brazil",
    review:
      "The best VPN service out there. It keeps me secure, and I can access all the content I need!",
    image: "https://randomuser.me/api/portraits/men/2.jpg",
  },
  {
    name: "Aisha K",
    country: "South Africa",
    review:
      "Excellent customer support and easy to set up. Geo VPN is the only VPN I trust.",
    image: "https://randomuser.me/api/portraits/women/3.jpg",
  },
  {
    name: "Yuki H",
    country: "Japan",
    review:
      "Geo VPN provides the fastest servers I've ever used, and I love the no-logs policy.",
    image: "https://randomuser.me/api/portraits/men/3.jpg",
  },
  {
    name: "Lena M",
    country: "Germany",
    review:
      "I'm impressed by how intuitive and reliable Geo VPN is. It connects instantly every time.",
    image: "https://randomuser.me/api/portraits/women/4.jpg",
  },
  {
    name: "Carlos P",
    country: "Spain",
    review:
      "Geo VPN has made it so much easier to access restricted content. Highly recommend!",
    image: "https://randomuser.me/api/portraits/men/4.jpg",
  },
  {
    name: "Yuki H",
    country: "Japan",
    review:
      "Geo VPN provides the fastest servers I've ever used, and I love the no-logs policy.",
    image: "https://randomuser.me/api/portraits/men/3.jpg",
  },
];

export default function Slider() {
  const breakpoints = [
    {
      breakpoint: 1000,
      cols: 2,
      rows: 1,
    },
    {
      breakpoint: 768,
      cols: 2,
      rows: 1,
    },
    {
      breakpoint: 647,
      cols: 2,
      rows: 1,
      gap: 0,
    },
    {
      breakpoint: 555,
      cols: 1,
      rows: 1,
      gap: 0,
      border: "20px solid red",
      justifyItems: "center",
    },
  ];

  return (
    <div className="mb-[40px] mt-[40px] lg:container md:mt-[82px]">
      <Carousel
        cols={3}
        rows={1}
        gap={"18px"}
        autoplay={1500}
        loop={true}
        showDots={false}
        hideArrow={true}
        dot={false}
        responsiveLayout={breakpoints}
        mobileBreakpoint={250}
        containerClassName={"carousel-container"}
      >
        {testimonials.map((testimonial, index) => (
          <Carousel.Item key={index}>
            <ReviewCard
              name={testimonial.name}
              image={testimonial.image}
              country={testimonial.country}
              review={testimonial.review}
            />
          </Carousel.Item>
        ))}
      </Carousel>
    </div>
  );
}
